export function formatDate(dateInput) {
  var res = new Date(
    Date.parse(
      new Intl.DateTimeFormat("fr-CA", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(new Date(dateInput))
    )
  )
    .toISOString()
    .split("T")[0];
  return res;
}

const removedColumns = (obj, columns) => {
  columns.forEach((column) => delete obj[column]);
  return obj;
};

export const getDefaultCoordinates = () => {
  let coordinate = { lat: "31.517106", lng: "74.363479" };
  return coordinate;
};

export const getCustomCloumns = (array, invisibleColumns) => {
  if (invisibleColumns != null && invisibleColumns.length > 0) {
    return array.map((row) => {
      return removedColumns(row, invisibleColumns);
    });
  } else return array;
};

export const getAdvertisementStatus = (status) => {
  switch (status) {
    case "Create":
      return 1;
    case "Active":
      return 2;
    case "Complete":
      return 3;
    case "Terminated":
      return 4;
    case "Expansion":
      return 5;
    default:
      return 1;
  }
};

export const getAdvertisementStatusName = (value) => {
  switch (value.toString()) {
    case "1":
      return "Create";
    case "2":
      return "Active";
    case "3":
      return "Complete";
    case "4":
      return "Terminated";
    case "5":
      return "Expansion";
    default:
      return "Create";
  }
};

export const getNotificationSchedularName = (value) => {
  switch (value.toString()) {
    case "1":
      return "Create";
    case "2":
      return "Active";
    case "3":
      return "Complete";
    default:
      return "Create";
  }
};

export const truncateString = (str, maxLength) => {
  if (str.length > maxLength) {
    return str.slice(0, maxLength) + "...";
  }
  return str;
};

export const getKYCApprovalStatus = (s, v) => {
  if (s && v) return "Approved";
  else return "Rejected";
};
export const getImageExtensions = () => {
  return ["jpg", "jpeg", "png", "heif", "avif", "apng", "xcf"];
};
export const MAX_FILE_SIZE_MB = 5;
export const getExcelSize = () => {
  return MAX_FILE_SIZE_MB * 1024 * 1024;
};

// Render cell with numeric detection
const isNumericValue = (value) => {
  if (value === null || value === undefined) return false;

  // If value ends with %, remove it before numeric check
  const cleaned =
    typeof value === "string" && value.trim().endsWith("%")
      ? value.trim().slice(0, -1)
      : value;

  return !isNaN(cleaned) && cleaned !== "";
};

export const renderCell = (value, formatNumber = false) => {
  const isNumeric = isNumericValue(value);

  let displayValue = value;
  if (formatNumber && isNumeric) {
    if (typeof value === "string" && value.trim().endsWith("%")) {
      const num = parseFloat(value);
      displayValue = `${num.toLocaleString()}%`;
    } else {
      displayValue = Number(value).toLocaleString();
    }
  }

  return (
    <div style={{ textAlign: isNumeric ? "right" : "left" }}>
      {displayValue}
    </div>
  );
};

export const renderHeader = (title) => (
  <div style={{ textAlign: "right", fontWeight: "bold" }}>{title}</div>
);

export const toCommaSeparated = (input, valueKey = "value") => {
  if (!input) return "";

  if (typeof input === "string") return input;

  if (!Array.isArray(input)) {
    return input?.[valueKey]?.toString() ?? "";
  }

  return input
    .map(item => item?.[valueKey])
    .filter(Boolean)
    .join(",");
};

export const mapCommaSeparatedToOptions = (
  input,
  list = [],
  valueKey = "value",
  labelKey = "label"
) => {
  if (!input) return [];

  if (Array.isArray(input)) return input;

  const valuesSet = new Set(
    input
      .split(",")
      .map(v => v.trim())
      .filter(Boolean)
  );

  return list
    .filter(item => valuesSet.has(item?.[valueKey]?.toString()))
    .map(item => ({
      label: item?.[labelKey],
      value: item?.[valueKey],
    }));
};
